module.exports = __webpack_public_path__ + "static/media/model-patrol-88-lwb.56523136.jpg";